import { useState, useCallback } from 'react'
import axios from 'axios'

export default function useGroupMessages(groupConversationId) {
  const [messages, setMessages] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const fetchGroupMessages = useCallback(async () => {
    if (!groupConversationId) return

    setIsLoading(true)
    try {
      const response = await axios.get(`/api/group_conversations/${groupConversationId}`)
      const attrs = response.data.data?.attributes || {}
      setMessages(attrs.messages || [])
    } catch (err) {
      console.error('Error fetching group messages:', err)
    } finally {
      setIsLoading(false)
    }
  }, [groupConversationId])

  const sendGroupMessage = useCallback(async (body) => {
    const response = await axios.post(`/api/group_conversations/${groupConversationId}/group_messages`, {
      group_message: { body }
    })
    const newMessage = response.data.data
    setMessages((prev) => [newMessage, ...prev])
    return newMessage
  }, [groupConversationId])

  const deleteGroupMessage = useCallback(async (messageId) => {
    await axios.delete(`/api/group_messages/${messageId}`)
    setMessages((prev) =>
      prev.map((m) =>
        m.id === messageId
          ? { ...m, attributes: { ...m.attributes, deletedAt: new Date().toISOString() } }
          : m
      )
    )
  }, [])

  const addGroupMessage = useCallback((message) => {
    setMessages((prev) => {
      const exists = prev.find((m) => m.id === message.id)
      if (exists) return prev
      return [message, ...prev]
    })
  }, [])

  const updateGroupMessage = useCallback((messageId, updates) => {
    setMessages((prev) =>
      prev.map((m) =>
        m.id?.toString() === messageId?.toString()
          ? { ...m, attributes: { ...m.attributes, ...updates } }
          : m
      )
    )
  }, [])

  return {
    messages,
    isLoading,
    fetchGroupMessages,
    sendGroupMessage,
    deleteGroupMessage,
    addGroupMessage,
    updateGroupMessage
  }
}
